// extracted by mini-css-extract-plugin
export default {"lessonQuestion":"SimpleLink_lessonQuestion__KDvXg","link":"SimpleLink_link__j1je0"};